// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixFieldSet } from '../Fields/PFixFieldSet';
export class AccountOperationStatisticGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ACCOUNT_OPERATION_STATISTIC_GROUP, null, pfixFieldSet);
    }
    getOperationType() {
        return this.GetValue(FieldsFactory.FIELD_OPERATION_TYPE2);
    }
    setOperationType(operationType) {
        this.SetField(FieldsFactory.FIELD_OPERATION_TYPE2, operationType);
    }
    getAmount() {
        return this.GetValue(FieldsFactory.FIELD_AMOUNT);
    }
    setAmount(amount) {
        this.SetField(FieldsFactory.FIELD_AMOUNT, amount);
    }
}
